// extracted by mini-css-extract-plugin
export var deleteModal = "_fi-0";